import React from 'react';

// Gemini の返答で頻出する記法だけを扱う軽量レンダラ
// - **bold**
// - 行頭の `*` / `-` / `•` / `1.` → 箇条書き
// - 通常の改行は <br /> 相当（<div> で維持）

function renderInline(text: string, keyPrefix: string): React.ReactNode[] {
  const parts: React.ReactNode[] = [];
  const re = /\*\*([^*]+?)\*\*/g;
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  let idx = 0;
  while ((match = re.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    parts.push(
      <strong key={`${keyPrefix}-b-${idx++}`}>{match[1]}</strong>,
    );
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }
  return parts;
}

interface Props {
  text: string;
}

export default function AgentMarkdown({ text }: Props) {
  const lines = text.split('\n');
  return (
    <>
      {lines.map((line, i) => {
        const listMatch = line.match(/^\s*(?:[*\-•]|\d+\.)\s+(.*)$/);
        if (listMatch) {
          return (
            <div
              key={`line-${i}`}
              style={{ paddingLeft: 16, textIndent: -12, lineHeight: 1.55 }}
            >
              • {renderInline(listMatch[1], `l${i}`)}
            </div>
          );
        }
        if (line.trim() === '') {
          return <div key={`line-${i}`} style={{ height: 6 }} />;
        }
        return (
          <div key={`line-${i}`} style={{ lineHeight: 1.55 }}>
            {renderInline(line, `l${i}`)}
          </div>
        );
      })}
    </>
  );
}
